export const notificationParams = {
  displayedPanel: false,
  hideNotifications: false,
};

export interface PFSNotification {
  id: string;
  isRead?: boolean;
  orderId: string;
  orderNumber: string;
  type: 'order' | 'transmission' | 'modification' | 'review' | 'cancellation' | 'refused' | 'expired';
}

export interface PFSNotifications {
  cancellations: PFSNotification[];
  modifications: PFSNotification[];
  orders: PFSNotification[];
  expired: PFSNotification[];
}

export interface PFSNotificationResponseDTO {
  id: string | null;
  messageDate: string | null;
  orderNumber: string | null;
  assignmentState: string | null;
  type: string | null;
  deliveryDate: string | null;
  isRead: boolean;
  orderId: string | null;
}

export enum NotificationType {
  ORDER = 'order',
  MODIFICATION = 'modification',
  REVIEW = 'review',
  TRANSMISSION = 'transmission',
  CANCELLATION = 'cancellation',
  EXPIRED = 'expired',
  NOSTATUS = 'nostatus',
}
